import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","min-height":"400px"} }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "card__head d-flex align-items-center" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Card, { class: "card--slim my-4" }, {
              content: _withCtx(() => [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("h6", _hoisted_8, _toDisplayString(`${_ctx.$t('AppResourceEP.Floors')} ${_ctx.riser.name}`), 1)
                  ]),
                  _createVNode(_component_NumberButtons, {
                    class: "ml-auto",
                    modelValue: _ctx.floorNumber,
                    minValue: 1,
                    maxValue: _ctx.maxFloorsNumber,
                    onIncrement: _cache[1] || (_cache[1] = ($event: any) => (_ctx.floorNumber++)),
                    onDecrement: _cache[2] || (_cache[2] = ($event: any) => (_ctx.floorNumber--))
                  }, null, 8, ["modelValue", "maxValue"])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("footer", _hoisted_9, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('AppResource.Cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.buttonSubmitLabel,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: _ctx.saveButtonDisabled
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}